import StarStarredIcon from '@atlaskit/icon/core/star-starred';
import * as React from 'react';

export function SvgStar() {
  return <StarStarredIcon label="" testId="ads-refreshed-icon" />;
}
